import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import PageSection from '../../components/PageSection';

const styles = theme => ({
  root: {
    padding: 20
  },
  intro: {
    marginTop: 30,
    marginBottom: 30,
    padding: 30,
    textAlign: 'center',
  },
  introTitle: {
    color: theme.palette.primary.main,
    fontSize: 48,
    fontWeight: 'bold',
    marginBottom: 30
  },
  font: {
    fontSize: 19,
    color: theme.palette.grey.main
  }
});

const competitions = [
  {
    id: 1,
    title: 'Steinway & Sons',
    description: 'The Steinway Junior Piano Competition offers cash prizes for piano performances.',
    image: 'https://musicology-studio.s3.amazonaws.com/Guild.jpg',
  },
  {
    id: 2,
    title: 'FIU',
    description: 'The Miami-Dade County Fair and Exposition hosts a competition held at Florida International University and is an opportunity for students to perform on stage before a panel of judges and an audience. The requirement for enrollment is 2 years of piano study and participants perform one memorized piece.  Students and families receive free entrance to the Miami-Dade Youth Fair, and students are awarded medals, ribbons, and cash prizes based on the award earned.',
    image: 'https://musicology-studio.s3.amazonaws.com/Youth_Fair_Competion.jpg',
  }
];


class Competitions extends Component {

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {competitions.map(c => <PageSection key={c.id} section={c} plain fullWidth divider circular /> )}
      </div>
    )
  }
}

export default withStyles(styles)(Competitions);
